<template>
  <div id="pageRoot">
    <img id="bg" class="pageElement" src="/pages/img/sordocas/svgCas24bg.svg" />
    <span class="normalTheme pageInstruction" style="left: 54px; top: 60px">
      <p>
        Escribe los nombres de los<br />
        alimentos que corresponde.
      </p>
    </span>

    <div
      class="text-box-a pageElement hover-animation-a"
      id="globe01"
      style="
        z-index: 3;
        background-image: url(/pages/img/sordo/svgPage75TextBox01.svg);
        background-size: cover;
      "
    >
      <p class="textBase" id="globe01Text">¡Son verdes!</p>
    </div>
    <p class="textBase" id="sign01">Verduras</p>

    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="1"
      id="inputField01"
    />
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="2"
      id="inputField02"
    />
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="3"
      id="inputField03"
    />

    <p id="tag01" class="textBase basicItem01 tagDefault">banana</p>
    <p id="tag02" class="textBase basicItem01 tagDefault">cerdo</p>
    <p id="tag03" class="textBase basicItem01 tagDefault">espinaca</p>
    <p id="tag04" class="textBase basicItem01 tagDefault">queso</p>
    <p id="tag05" class="textBase basicItem01 tagDefault">uva</p>
    <p id="tag06" class="textBase basicItem01 tagDefault">pescado</p>
    <p id="tag07" class="textBase basicItem01 tagDefault">maíz</p>

    <p id="tag11" class="textBase basicItem01 tagDefault">arroz</p>
    <p id="tag12" class="textBase basicItem01 tagDefault">lechuga</p>
    <p id="tag13" class="textBase basicItem01 tagDefault">yogur</p>
    <p id="tag14" class="textBase basicItem01 tagDefault">pollo</p>
    <p id="tag15" class="textBase basicItem01 tagDefault">pepino</p>
    <p id="tag16" class="textBase basicItem01 tagDefault">durazno</p>
    <p id="tag17" class="textBase basicItem01 tagDefault">manteca</p>
    <p id="tag18" class="textBase basicItem01 tagDefault">avena</p>
  </div>
</template>
<style scoped>
#bg {
  position: absolute;
  left: 0px;
  top: 288px;
  z-index: -1;
}

#globe01 {
  position: absolute;
  width: 387.15px;
  height: 115px;
  left: 18px;
  top: 224px;
}
#globe01Text {
  position: absolute;
  left: 24%;
  top: 18%;
  font-size: 36px;
  line-height: 40px;
  color: #fbf8f8;
}
#sign01 {
  position: absolute;
  left: 263px;
  top: 349px;
  font-size: 33px;
  color: white;
  transform: rotate(-1.3deg);
}
#inputField01 {
  position: absolute;
  width: 327px;
  height: 50px;
  left: 105px;
  top: 437px;
  
}
#inputField02 {
  position: absolute;
  width: 327px;
  height: 50px;
  left: 105px;
  top: 527px;
}
#inputField03 {
  position: absolute;
  width: 327px;
  height: 50px;
  left: 105px;
  top: 617px;
}

#tag01 {
  position: absolute;
  width: 190px;
  text-align: center;
  left: 536px;
  top: 51px;
}
#tag02 {
  position: absolute;
  width: 190px;
  text-align: center;
  left: 536px;
  top: 136px;
}
#tag03 {
  position: absolute;
  width: 190px;
  text-align: center;
  left: 536px;
  top: 225px;
}
#tag04 {
  position: absolute;
  width: 190px;
  text-align: center;
  left: 536px;
  top: 312px;
}
#tag05 {
  position: absolute;
  width: 190px;
  text-align: center;
  left: 536px;
  top: 401px;
}
#tag06 {
  position: absolute;
  width: 190px;
  text-align: center;
  left: 536px;
  top: 486px;
}
#tag07 {
  position: absolute;
  width: 190px;
  text-align: center;
  left: 536px;
  top: 575px;
}
#tag11 {
  position: absolute;
  width: 190px;
  text-align: center;
  left: 776px;
  top: 51px;
}
#tag12 {
  position: absolute;
  width: 190px;
  text-align: center;
  left: 776px;
  top: 136px;
}
#tag13 {
  position: absolute;
  width: 190px;
  text-align: center;
  left: 776px;
  top: 225px;
}
#tag14 {
  position: absolute;
  width: 190px;
  text-align: center;
  left: 776px;
  top: 312px;
}
#tag15 {
  position: absolute;
  width: 190px;
  text-align: center;
  left: 776px;
  top: 401px;
}
#tag16 {
  position: absolute;
  width: 190px;
  text-align: center;
  left: 776px;
  top: 486px;
}
#tag17 {
  position: absolute;
  width: 190px;
  text-align: center;
  left: 776px;
  top: 575px;
}
#tag18 {
  position: absolute;
  width: 190px;
  text-align: center;
  left: 776px;
  top: 663px;
}
</style>
<script>
export default {
  data() {
    return {
      videos: [
        "cas/Video 83.mp4",
        "cas/Video 84.mp4",
        "cas/Video 85.mp4",
        "cas/Video 86.mp4",
        "cas/Video 87.mp4",
        "cas/Video 88.mp4",
        "cas/Video 89.mp4",
        "cas/Video 90.mp4",
        "cas/Video 91.mp4",
        "cas/Video 92.mp4",
        "cas/Video 93.mp4",
        "cas/Video 94.mp4",
        "cas/Video 95.mp4",
        "cas/Video 96.mp4",
        "cas/Video 97.mp4",
        "cas/Video 98.mp4",

        "cas/Video 100.mp4",
      ],
    };
  },
};
</script>